// @ts-ignore
import { Heading, Text } from '@plurall/elo-beta'

import styles from './ErrorMessage.module.scss'

interface IErrorMessageProps {
  src?: string
  subTitle?: string
  title?: string
}

const ErrorMessage = ({ src, subTitle, title }: IErrorMessageProps) => (
  <div className={styles['no-results']}>
    <img src={src} alt='Sem resultados' />
    <div className={styles['title-wrapper']}>
      <Heading size='h2' textAlign='center' variant='brand' secondary>
        {title || 'Corremos e voamos, mas não encontramos o que você busca.'}
      </Heading>
    </div>
    {subTitle && <Text>{subTitle}</Text>}
  </div>
)

export default ErrorMessage
